// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart

export default function padStart(string: string, length: number, padStringInput: string) {
  let targetLength = length >> 0; // truncate if number, or convert non-number to 0;
  let padString = String(typeof padStringInput !== 'undefined' ? padStringInput : ' ');
  if (string.length >= targetLength) {
    return String(string);
  }
  targetLength = targetLength - string.length;
  if (targetLength > padString.length) {
    // append to original to ensure we are longer than needed
    padString += padString.repeat(targetLength / padString.length);
  }
  return padString.slice(0, targetLength) + String(string);
}



// WEBPACK FOOTER //
// ./src/components/AddressEditor/padStart.ts